import { TYPE, TYPE_INSTAGRAM } from '@kontentino/kontentino-constants/Pages';

const Posts = {
  GRID_VIEW_SUPPORTED_TYPES: [TYPE_INSTAGRAM, TYPE.TIKTOK] as number[],
  isGridViewSupportedForProfiles(profiles: { type: number }[]): boolean {
    if (profiles.length === 0) return false;
    const profileType = profiles[0].type;
    return (
      Posts.GRID_VIEW_SUPPORTED_TYPES.includes(profileType) &&
      profiles.every((p) => p.type === profileType)
    );
  },
  isGridViewMixedTypeSelection(profiles: { type: number }[]): boolean {
    if (profiles.length === 0) return false;
    const allSupported = profiles.every((p) =>
      Posts.GRID_VIEW_SUPPORTED_TYPES.includes(p.type),
    );
    const firstType = profiles[0].type;
    const allSameType = profiles.every((p) => p.type === firstType);
    return allSupported && !allSameType;
  },
};

export default Posts;
